import { render, staticRenderFns } from "./priceDetail.vue?vue&type=template&id=594c6274&scoped=true&"
import script from "./priceDetail.vue?vue&type=script&lang=js&"
export * from "./priceDetail.vue?vue&type=script&lang=js&"
import style0 from "./priceDetail.vue?vue&type=style&index=0&id=594c6274&prod&scoped=true&lang=scss&"
import style1 from "./priceDetail.vue?vue&type=style&index=1&id=594c6274&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "594c6274",
  null
  
)

export default component.exports